import { Stack, Typography, Grid } from '@mui/material';
import { startCase } from 'lodash';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';

// Components
import Table from 'src/components/Table';

// Utilities
import { useQueryListAlertPeople } from 'src/services/queries';
import { FORMAT_DATE_TIME, LIMIT_GET_LIST } from 'src/utils/constants/config';
import { renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
// import DisclaimerAlert from 'src/components/common/DisclaimerAlert';
import PeopleDetailCardContent from 'src/features/PeopleDetail/components/CardContent';
import PopupAlertsDetail from 'src/features/PeopleDetail/components/PopupAlertsDetail';
import { formatUTCTime } from 'src/utils/helpers/dayjs';

const Alerts = () => {
  const { id } = useParams();
  const [openAlertDetail, setOpenAlertDetail] = useState<{ open: boolean; alert: IAlertPeople | null }>({
    open: false,
    alert: null,
  });
  const [params, setParams] = useState({
    limit: LIMIT_GET_LIST,
    offset: 0,
  });
  const { data, isFetching } = useQueryListAlertPeople({
    id: id || '',
    params,
  });

  const handleOpenAlertDetail = (alert: IAlertPeople) => {
    setOpenAlertDetail({ open: true, alert: alert });
  };

  const handleCloseAlertDetail = () => {
    setOpenAlertDetail({ open: false, alert: null });
  };

  const configColumn: ConfigCell<IAlertPeople>[] = [
    {
      id: 'authority',
      disablePadding: true,
      label: 'Authority',
      align: 'left',
      cell: (row: IAlertPeople) => {
        return (
          <Typography variant="body2" color="secondary" onClick={() => handleOpenAlertDetail(row)}>
            {renderTextOrDefault(row.authority)}
          </Typography>
        );
      },
    },
    {
      id: 'program',
      disablePadding: false,
      label: 'Program',
      align: 'right',
      cell: (row: IAlertPeople) => {
        return (
          <Typography variant="body2" color="text.secondary" align="right">
            {renderTextOrDefault(startCase(row.program || ''))}
          </Typography>
        );
      },
    },
    {
      id: 'start_date',
      disablePadding: false,
      label: 'Start Date',
      align: 'right',
      cell: (row: IAlertPeople) => {
        return (
          <Typography variant="body2" color="text.secondary" align="right">
            {formatUTCTime(FORMAT_DATE_TIME.FULL_ONLY_DATE, row?.start_date || '')}
          </Typography>
        );
      },
    },
    {
      id: 'end_date',
      disablePadding: false,
      label: 'End Date',
      align: 'right',
      cell: (row: IAlertPeople) => {
        return (
          <Typography variant="body2" color="text.secondary" align="right">
            {formatUTCTime(FORMAT_DATE_TIME.FULL_ONLY_DATE, row?.end_date || '')}
          </Typography>
        );
      },
    },
  ];

  return (
    <Grid item xs={12}>
      <PeopleDetailCardContent title="Alerts">
        <Stack spacing={3}>
          {/* <DisclaimerAlert
            title="ADAMftd Disclaimer "
            content={
              <Typography variant="body1" align="left">
                ADAMftd does not assume responsibility for the accuracy, completeness, or relevance of the data for
                entities listed below. The inclusion of any individual or organization in this sanctions list does not
                imply any inference or judgment by ADAMftd. Users are encouraged to independently verify and interpret
                the information provided.
              </Typography>
            }
          /> */}
          <Table
            maxRow={5}
            onChangePage={(e) => setParams({ ...params, ...{ offset: e } })}
            onChangePageSize={(e) => setParams({ ...params, ...{ offset: 0, limit: e } })}
            page={params.offset}
            pageSize={params.limit}
            loading={isFetching}
            data={getArrayDefault(data?.data)}
            totalRecords={data.total_docs_count}
            configColumn={configColumn}
            dataKey="id"
          />
        </Stack>
      </PeopleDetailCardContent>
      <PopupAlertsDetail
        open={openAlertDetail.open}
        alert={openAlertDetail.alert}
        handleClose={handleCloseAlertDetail}
      />
    </Grid>
  );
};

export default Alerts;
